export default {
    data() {
        return {
        conditionSubjectOptions: [

                { text: 'Item', value: 'item' },
                { text: 'Disc', value: 'disc' },
                { text: 'Cover', value: 'cover' },
                { text: 'Label', value: 'label' },
                { text: 'Cassette', value: 'cassette'},
                { text: 'Insert', value: 'insert'},
                { text: 'Case', value: 'case'},
            ]
        }
    }
}